import { GraphicLabel } from 'components/results'
import { Container, DashedArea, StyledGraphic } from './graphic-styles'
import {
  MAX_TAG_QUESTIONS,
  QUESTION_HEIGHT,
  GRAPHIC_HEIGHT,
} from 'helpers/constants'
import { calculateQuestionHeight } from 'helpers'

const Graphic = ({
  quantities,
  maxTagQuestions = MAX_TAG_QUESTIONS,
  onClick = null,
  hasSquareBorder = false,
  lastGraph = false,
  isProportional = false,
}: any) => {
  const questionHeight = isProportional
    ? calculateQuestionHeight(GRAPHIC_HEIGHT, maxTagQuestions)
    : QUESTION_HEIGHT

  return (
    <Container>
      <GraphicLabel quantities={quantities} maxTagQuestions={maxTagQuestions}>
        <DashedArea
          display='flex'
          flexDirection='column'
          justifyContent='center'
          alignItems='center'
          quantities={quantities}
          maxTagQuestions={maxTagQuestions}
          questionHeight={questionHeight}
          onClick={lastGraph ? undefined : onClick}
        >
          <StyledGraphic
            className='test'
            quantities={quantities}
            hasClick={Boolean(onClick) && !lastGraph ? true : undefined}
            questionHeight={questionHeight}
            hasSquareBorder={hasSquareBorder}
          />
        </DashedArea>
      </GraphicLabel>
    </Container>
  )
}

export default Graphic
